"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.restoreField = exports.updateField = exports.updateCollection = exports.getPaths = exports.setPath = exports.downloadData = exports.updateData = exports.uploadData = exports.verbose = void 0;
var FC = require("./fire_constants");
exports.verbose = false;
function output(str) {
    if (exports.verbose) {
        console.log(str);
    }
}
function uploadData(db, collection, doc, data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            db.collection(collection).doc(doc).set(data).
                then(function () {
                output("Data for document " + doc + " successfully uploaded to collection " + collection);
            }).
                catch(function (error) {
                output("Uploading data to document " + doc + " in collection " + collection + " failed with: " + error);
            });
            return [2];
        });
    });
}
exports.uploadData = uploadData;
function updateData(db, collection, path, data, nesting) {
    return __awaiter(this, void 0, void 0, function () {
        var entry, key;
        return __generator(this, function (_a) {
            entry = {};
            key = nesting.join('.');
            entry[key] = data;
            db.collection(collection).doc(path).update(entry).
                then(function () {
                output("Data successfully updated in collection " + collection + " with path " + path);
            }).
                catch(function (error) {
                output("Updating data in collection " + collection + " with path " + path + " failed with: " + error);
            });
            return [2];
        });
    });
}
exports.updateData = updateData;
function downloadData(db, collection, path) {
    return __awaiter(this, void 0, void 0, function () {
        var doc;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, db.collection(collection).doc(path).get()];
                case 1:
                    doc = _a.sent();
                    return [2, doc.data()];
            }
        });
    });
}
exports.downloadData = downloadData;
function setPath(db, collection, path, value) {
    if (value === void 0) { value = true; }
    return __awaiter(this, void 0, void 0, function () {
        var doc, paths, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    doc = path.split('/')[0];
                    return [4, db.collection(collection).doc(doc).get()];
                case 1:
                    paths = _a.sent();
                    data = paths.data();
                    if (!data) {
                        data = {};
                    }
                    data[path] = value;
                    uploadData(db, collection, doc, data);
                    return [2];
            }
        });
    });
}
exports.setPath = setPath;
function getPaths(db, collection, doc) {
    return __awaiter(this, void 0, void 0, function () {
        var path, paths;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    path = doc.split('/')[0];
                    return [4, db.collection(collection).doc(path).get()];
                case 1:
                    paths = _a.sent();
                    return [2, paths.data()];
            }
        });
    });
}
exports.getPaths = getPaths;
function updateCollection(db, collA, collB, doc, callback) {
    if (callback === void 0) { callback = function (_x, _y) { }; }
    return __awaiter(this, void 0, void 0, function () {
        var result, paths, pathsB, _a, _b, _c, path, _d, name_1, info, dataA, dataB, tests, _e, _f, key, entryA, e_1_1, e_2_1;
        var e_2, _g, e_1, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    result = [];
                    return [4, getPaths(db, collA, doc)];
                case 1:
                    paths = _j.sent();
                    if (!paths) {
                        return [2, result];
                    }
                    return [4, getPaths(db, collB, doc)];
                case 2:
                    pathsB = _j.sent();
                    _j.label = 3;
                case 3:
                    _j.trys.push([3, 21, 22, 23]);
                    _a = __values(Object.entries(paths)), _b = _a.next();
                    _j.label = 4;
                case 4:
                    if (!!_b.done) return [3, 20];
                    _c = __read(_b.value, 2), path = _c[0], _d = __read(_c[1], 2), name_1 = _d[0], info = _d[1];
                    callback(path, Object.keys(paths));
                    result.push({
                        name: name_1,
                        information: info,
                        path: path
                    });
                    if (pathsB && pathsB[path] && !path.match(/^nemeth\/rules/)) {
                        return [3, 19];
                    }
                    return [4, downloadData(db, collA, path)];
                case 5:
                    dataA = _j.sent();
                    return [4, downloadData(db, collB, path)];
                case 6:
                    dataB = _j.sent();
                    if (!!dataB) return [3, 9];
                    setTestsStatus(dataA);
                    setTestsFeedback(dataA);
                    return [4, uploadData(db, collB, path, dataA)];
                case 7:
                    _j.sent();
                    return [4, setPath(db, collB, path)];
                case 8:
                    _j.sent();
                    return [3, 19];
                case 9:
                    tests = dataB.tests;
                    _j.label = 10;
                case 10:
                    _j.trys.push([10, 15, 16, 17]);
                    _e = (e_1 = void 0, __values(dataA.order)), _f = _e.next();
                    _j.label = 11;
                case 11:
                    if (!!_f.done) return [3, 14];
                    key = _f.value;
                    if (tests[key]) {
                        return [3, 13];
                    }
                    entryA = dataA.tests[key];
                    setStatus(entryA);
                    setFeedback(entryA);
                    return [4, updateData(db, collB, path, entryA, ['tests', key])];
                case 12:
                    _j.sent();
                    _j.label = 13;
                case 13:
                    _f = _e.next();
                    return [3, 11];
                case 14: return [3, 17];
                case 15:
                    e_1_1 = _j.sent();
                    e_1 = { error: e_1_1 };
                    return [3, 17];
                case 16:
                    try {
                        if (_f && !_f.done && (_h = _e.return)) _h.call(_e);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7];
                case 17: return [4, updateData(db, collB, path, dataA.order, ['order'])];
                case 18:
                    _j.sent();
                    _j.label = 19;
                case 19:
                    _b = _a.next();
                    return [3, 4];
                case 20: return [3, 23];
                case 21:
                    e_2_1 = _j.sent();
                    e_2 = { error: e_2_1 };
                    return [3, 23];
                case 22:
                    try {
                        if (_b && !_b.done && (_g = _a.return)) _g.call(_a);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7];
                case 23: return [2, result];
            }
        });
    });
}
exports.updateCollection = updateCollection;
function updateField(db, collection, path, field, value) {
    return __awaiter(this, void 0, void 0, function () {
        var data, _a, _b, key, e_3_1;
        var e_3, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4, downloadData(db, collection, path)];
                case 1:
                    data = _d.sent();
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 7, 8, 9]);
                    _a = __values(data.order), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [3, 6];
                    key = _b.value;
                    return [4, updateData(db, collection, path, value, ['tests', key, field])];
                case 4:
                    _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [3, 3];
                case 6: return [3, 9];
                case 7:
                    e_3_1 = _d.sent();
                    e_3 = { error: e_3_1 };
                    return [3, 9];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_3) throw e_3.error; }
                    return [7];
                case 9: return [2];
            }
        });
    });
}
exports.updateField = updateField;
function restoreField(db, collA, collB, doc, field) {
    return __awaiter(this, void 0, void 0, function () {
        var dataA, dataB, _a, _b, key, testA, value, e_4_1;
        var e_4, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4, downloadData(db, collA, doc)];
                case 1:
                    dataA = _d.sent();
                    return [4, downloadData(db, collB, doc)];
                case 2:
                    dataB = _d.sent();
                    if (!dataB) {
                        return [2];
                    }
                    _d.label = 3;
                case 3:
                    _d.trys.push([3, 8, 9, 10]);
                    _a = __values(dataB.order), _b = _a.next();
                    _d.label = 4;
                case 4:
                    if (!!_b.done) return [3, 7];
                    key = _b.value;
                    testA = dataA.tests[key];
                    if (!testA) {
                        return [3, 6];
                    }
                    value = testA[field];
                    if (typeof value === 'undefined') {
                        return [3, 6];
                    }
                    return [4, updateData(db, collB, doc, value, ['tests', key, field])];
                case 5:
                    _d.sent();
                    _d.label = 6;
                case 6:
                    _b = _a.next();
                    return [3, 4];
                case 7: return [3, 10];
                case 8:
                    e_4_1 = _d.sent();
                    e_4 = { error: e_4_1 };
                    return [3, 10];
                case 9:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_4) throw e_4.error; }
                    return [7];
                case 10: return [2];
            }
        });
    });
}
exports.restoreField = restoreField;
function setTestsStatus(tests) {
    var e_5, _a;
    try {
        for (var _b = __values(Object.values(tests.tests)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var entry = _c.value;
            setStatus(entry);
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_5) throw e_5.error; }
    }
}
function setStatus(entry) {
    entry[FC.Interaction] = 0;
}
function setTestsFeedback(tests) {
    var e_6, _a;
    try {
        for (var _b = __values(Object.values(tests.tests)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var entry = _c.value;
            setFeedback(entry);
        }
    }
    catch (e_6_1) { e_6 = { error: e_6_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_6) throw e_6.error; }
    }
}
function setFeedback(entry) {
    entry[FC.FeedbackStatus] = 0;
}
